const map = {
	"./404.svg": 19392,
	"./ca.svg": 98648,
	"./cdlp.svg": 40353,
	"./fe.svg": 5087,
	"./gpo-xcaret-h-logo-w.svg": 33209,
	"./gpo-xcaret-h-logo.svg": 75941,
	"./hcdp.svg": 97319,
	"./hxa.svg": 65665,
	"./hxm.svg": 26645,
	"./logo.svg": 16053,
	"./logo_xc.svg": 21251,
	"./logotype-w.svg": 36945,
	"./symbol-color.svg": 10438,
	"./xa.svg": 91417,
	"./xc.svg": 60411,
	"./xe.svg": 6901,
	"./xh.svg": 10384,
	"./xi.svg": 68302,
	"./xo.svg": 76271,
	"./xp.svg": 15000,
	"./xpf.svg": 33334,
	"./xs.svg": 65739,
	"./ya.svg": 19034
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89798;